import React, { useCallback, useEffect, useMemo, useState } from 'react';

import FileSaver from 'file-saver';

import { IoIosCloseCircleOutline } from 'react-icons/io';

import AsyncSelect from 'react-select/async';

import { toast } from 'react-toastify';

import moment from 'moment';

import 'moment/locale/pt-br';

import locale from 'antd/es/date-picker/locale/pt_BR';

import { Row, Col, Radio, DatePicker, Button, Checkbox } from 'antd';

import { Breadcumbs } from '~/components/Breadcumbs';
import { BackButton } from '~/components/BackButton';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxContent,
  BoxButtonDownload,
  BoxRadios,
  TitleSection,
  resetButtonStyle,
  ContainerGroups,
} from './style';
import ButtonBase from '~/components/Button';
import { dataLcs } from './data/indicadores-data';
import api from '~/services/api';
import { useSelector } from 'react-redux';

moment.locale('pt-br');

const Download = () => {
  const { MonthPicker } = DatePicker;

  const { token, roles, institutionId } = useSelector(state => state.auth);

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');
  const ROLE_MANAGER = roles.includes('ROLE_MANAGER');

  const isAdmin = useMemo(() => {
    return ROLE_ADMIN;
  }, []);

  const [loading, setLoading] = useState(false);

  const [downloadType, setDownloadType] = useState(null);
  const [dateType, setDateType] = useState();
  const [lc, setLc] = useState(null);

  const [mesInicio, setMesInicio] = useState();
  const [anoInicio, setAnoInicio] = useState();

  const [mesFim, setMesFim] = useState();
  const [anoFim, setAnoFim] = useState();

  const [institution, setInstitution] = useState(null);

  const [institutionIds, setInstitutionIds] = useState([]);
  const [institutionName, setInstitutionName] = useState(null);

  const [category, setCategory] = useState(null);
  const [todos, setTodos] = useState(null);

  const [isProfile, setIsProfile] = useState(false);

  const [disableFilterInst, setDisableFilterInst] = useState(false);

  useEffect(() => {
    if (downloadType === 'p') {
      setIsProfile(true);
    } else {
      setIsProfile(false);
    }
    setDateType(null);
    setLc(null);
  }, [downloadType]);

  // Reset Categorias e Todos
  useEffect(() => {
    if (category) {
      setTodos(null);
      setInstitutionIds([]);
      setInstitution(null);
    }
  }, [category]);

  useEffect(() => {
    if (todos) {
      setDisableFilterInst(true);
      setCategory(null);
      setInstitutionIds([]);
      setInstitution(null);
    } else {
      setDisableFilterInst(false);
    }
  }, [todos]);

  useEffect(() => {
    if (institution) {
      const res = institution?.map(item => item.value);
      const names = institution?.map(item => item.label);

      setInstitutionIds(res?.toString());
      setInstitutionName(names?.toString()?.replace(',', ' - '));
    }
  }, [institution]);

  const [yearOpen, setYearOpen] = useState(false);
  const [endYearOpen, setEndYearOpen] = useState(false);

  const handleStartDate = useCallback(
    dateString => {
      let date;

      setYearOpen(false);

      if (isProfile) {
        date = moment(dateString)
          .format('MM/YYYY')
          ?.split('/');
      } else {
        date = dateString?.split('/');
      }

      setMesInicio(date[0]);
      setAnoInicio(date[1]);
    },
    [setMesInicio, setAnoInicio, isProfile]
  );

  const handleEndDate = useCallback(
    dateString => {
      let date;
      setEndYearOpen(false);

      if (isProfile) {
        date = moment(dateString)
          .format('MM/YYYY')
          ?.split('/');
      } else {
        date = dateString?.split('/');
      }

      setMesFim(date[0]);
      setAnoFim(date[1]);
    },
    [setMesFim, setAnoFim, isProfile]
  );

  //

  const saveCSVFile = useCallback(
    data => {
      const lcName = lc ? lc : 'perfil';
      const nameInst = institutionName ? institutionName : '';
      const catInst = category || '';
      const periodo = `${mesInicio}${anoInicio}-${mesFim}${anoFim}`;

      const BOM = '\uFEFF';
      const csvData = BOM + data;
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });

      FileSaver.saveAs(blob, `${lcName}-${nameInst}${catInst}-${periodo}.csv`);
    },
    [institutionName, lc, category, mesInicio, anoInicio, mesFim, anoFim]
  );

  const getDownloadDados = useCallback(async () => {
    if (!downloadType) {
      toast.error('Escolha um tipo de dado para ser extraídos.', {
        autoClose: 7000,
      });

      return;
    }

    if (isAdmin && !category && !todos && institutionIds.length < 1) {
      toast.error(
        'Selecione qual a instituição ou grupo de instituições para realizar o download dos resultados.',
        {
          autoClose: 7000,
        }
      );

      return;
    }

    if (!isProfile && !dateType && downloadType === 'r') {
      toast.error('Escolha Mensal ou Anual.', {
        autoClose: 7000,
      });

      return;
    }

    if (!isProfile && !lc) {
      toast.error(
        'Selecione a origem dos dados que você deseja fazer download.',
        {
          autoClose: 7000,
        }
      );

      return;
    }

    if (!mesInicio && !anoInicio && !mesFim && !anoFim) {
      toast.error(
        ' Selecione qual o período que você deseja filtrar para o download de resultados.',
        {
          autoClose: 7000,
        }
      );

      return;
    }
    // Modelo endpoint download de dados
    // http://localhost:8080/instituicao/download-dados/?tipoDados=r&tipoAgrupamentoResultado=a
    //&idsInstituicao=&linhaCuidado=indicadores_painel_geral&mesInicio=1&anoInicio=2019&mesFim=12&anoFim=2020&category=SIHOSP

    const endPointDates = `&mesInicio=${mesInicio ||
      ''}&anoInicio=${anoInicio || ''}&mesFim=${mesFim || ''}&anoFim=${anoFim ||
      ''}`;

    const endPointAgrupamento = `&tipoAgrupamentoResultado=${
      !isProfile ? dateType : 'a'
    }`;

    const endPointLcs = `&linhaCuidado=${lc || ''}`;

    const endPointInstituitions = isAdmin
      ? `&idsInstituicao=${institutionIds?.length > 0 ? institutionIds : ''}`
      : `&idsInstituicao=${institutionId}`;

    const endPointCategory = category ? `&category=${category}` : '';

    const endPointString = `tipoDados=${downloadType}${endPointAgrupamento}${endPointInstituitions}${endPointLcs}${endPointDates}${endPointCategory}`;

    setLoading(true);
    try {
      const result = await api.get(
        `instituicao/download-dados/?${endPointString}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: String(token),
          },
        }
      );
      saveCSVFile(result.data);
    } catch (e) {
      const error = e?.response?.data?.fields[0]?.exception;
      toast.error(error || 'Não foi possível concluir sua solicitação', {
        autoClose: 7000,
      });
    } finally {
      setLoading(false);
    }
  }, [
    saveCSVFile,
    setLoading,
    downloadType,
    dateType,
    lc,
    institutionIds,
    mesInicio,
    anoInicio,
    mesFim,
    anoFim,
    category,
    todos,
    isProfile,
    isAdmin,
  ]);

  const theme = theme => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#f3f3f3',
    },
  });

  const filterInstitution = async (inputValue, callback) => {
    if (!inputValue) {
      return;
    }

    const response = await api.get(
      `instituicoes?limit=10&filter=${inputValue}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const data = response.data.map(hosp => ({
      value: hosp.id,
      label: hosp.nomeFantasia,
    }));

    callback(data);
  };

  const resetAll = useCallback(() => {
    setDownloadType(null);
    setDateType(null);
    setLc(null);

    setMesInicio(null);
    setAnoInicio(null);
    setMesFim(null);
    setAnoFim(null);

    setInstitution(null);
    setInstitutionIds([]);

    setCategory(null);
    setTodos(null);
  }, []);

  const ButtonReset = () => {
    return (
      <Button style={resetButtonStyle} onClick={resetAll}>
        <IoIosCloseCircleOutline size={18} style={{ marginRight: '5px' }} />
        Limpar
      </Button>
    );
  };

  const normalizeDate = useCallback(periodo => {
    let periodoIn;
    if (!periodo) {
      periodoIn = '';
    } else {
      const splitDate = periodo.split('/');
      periodoIn = moment(`${splitDate[1]}-${splitDate[0]}`, 'YYYY-MM');
    }

    return periodoIn;
  }, []);

  const handleAll = useCallback(({ target }) => {
    setTodos(target?.checked);
  }, []);

  useEffect(() => {
    console.log('todos', todos);
  }, [todos]);

  const GruposInsituicoes = () => (
    <ContainerGroups>
      <Row>
        <Col span={5}>
          <div className="todosCheckbox">
            <Checkbox onChange={handleAll} value={todos} checked={todos}>
              Todos
            </Checkbox>
          </div>
        </Col>

        <Col span={5}>
          <Radio
            disabled={downloadType !== 'r'}
            onClick={() => setCategory('SIHOSP')}
            value={category}
            checked={category === 'SIHOSP'}
          >
            SIHOSP
          </Radio>
        </Col>

        <Col span={5}>
          <Radio
            disabled={downloadType !== 'r'}
            onClick={() => setCategory('PROADI')}
            value={category}
            checked={category === 'PROADI'}
          >
            PROADI
          </Radio>
        </Col>
      </Row>
    </ContainerGroups>
  );

  return (
    <div>
      <Breadcumbs path="area-de-suporte" pathTitle="Área de suporte" />
      <BreadcumbsContainer>
        <BackButton />
      </BreadcumbsContainer>
      <PageTitle>
        <div className="headerInline">
          <span>Download de dados</span>
        </div>
      </PageTitle>

      <BoxContent>
        <Row type="flex" justify="space-between">
          <Col span={8}>
            <TitleSection>
              > Tipos de dados extraídos:
              <span>(marcar apenas uma)</span>
            </TitleSection>
          </Col>
          <Col span={2}>
            <ButtonReset />
          </Col>
        </Row>

        <BoxRadios>
          <Row>
            <Col span={4}>
              <Radio
                onClick={() => setDownloadType('p')}
                value={downloadType}
                checked={downloadType === 'p'}
              >
                Perfil {(ROLE_ADMIN && 'dos hospitais') || (ROLE_MANAGER && 'do hospital')}
              </Radio>
            </Col>

            <Col span={4}>
              <Radio
                onClick={() => setDownloadType('b')}
                value={downloadType}
                checked={downloadType === 'b'}
              >
                Dados brutos
              </Radio>
            </Col>

            <Col span={4}>
              <Radio
                onClick={() => setDownloadType('r')}
                value={downloadType}
                checked={downloadType === 'r'}
              >
                Resultados
              </Radio>
            </Col>
          </Row>

          <br />

          <Row>
            <Col span={4}>
              <Radio
                disabled={isProfile || downloadType !== 'r'}
                onClick={() => setDateType('m')}
                value={dateType}
                checked={dateType === 'm'}
              >
                Mensal
              </Radio>
            </Col>

            <Col span={4}>
              <Radio
                disabled={isProfile || downloadType !== 'r'}
                onClick={() => setDateType('a')}
                value={dateType}
                checked={dateType === 'a'}
              >
                Anual
              </Radio>
            </Col>
          </Row>
        </BoxRadios>

        <hr />

        <Row>
          {isAdmin && (
            <Col span={12}>
              <TitleSection>
                > Selecione qual a instituição ou grupo de instituições para
                realizar o download dos resultados:
              </TitleSection>

              <GruposInsituicoes />
              <div className="boxSelect">
                <AsyncSelect
                  isDisabled={disableFilterInst || category !== null}
                  cacheOptions
                  value={institution}
                  defaultOptions
                  isMulti
                  onChange={item => {
                    setInstitution(item);
                  }}
                  loadOptions={filterInstitution}
                  placeholder="Pesquise"
                  noOptionsMessage={() => 'Pesquise por instituição'}
                  loadingMessage={() => 'Carregando...'}
                  theme={theme}
                />
              </div>
            </Col>
          )}

          <Col span={12}>
            <div style={{ paddingLeft: isAdmin ? 30 : 0 }}>
              <TitleSection>
                > Selecione qual o período que você deseja filtrar para o
                download de resultados:
              </TitleSection>

              <div className="dataPickerContent">
                <div>
                  {isProfile ? (
                    <DatePicker
                      mode="year"
                      placeholder="Selecione o ano"
                      open={yearOpen}
                      value={
                        anoInicio && anoInicio
                          ? normalizeDate(`${mesInicio}/${anoInicio}`)
                          : null
                      }
                      onPanelChange={e => console.log(e)}
                      name="startDate"
                      id={`startDate`}
                      format="YYYY"
                      locale={locale}
                      onPanelChange={value => {
                        handleStartDate(value);
                      }}
                      onOpenChange={status => {
                        setYearOpen(status);
                      }}
                    />
                  ) : (
                    <MonthPicker
                      value={
                        mesInicio && anoInicio
                          ? normalizeDate(`${mesInicio}/${anoInicio}`)
                          : null
                      }
                      name="startDate"
                      id={`startDate`}
                      format="MM/YYYY"
                      locale={locale}
                      placeholder="Mês / Ano"
                      onChange={(value, dateString) => {
                        handleStartDate(dateString);
                      }}
                    />
                  )}
                </div>
                <div style={{ marginLeft: 30 }}>
                  {isProfile ? (
                    <DatePicker
                      open={endYearOpen}
                      mode="year"
                      placeholder="Selecione o ano"
                      value={
                        mesFim && anoFim
                          ? normalizeDate(`${mesFim}/${anoFim}`)
                          : null
                      }
                      name="startDate"
                      id={`startDate`}
                      format="YYYY"
                      locale={locale}
                      onPanelChange={value => {
                        handleEndDate(value);
                      }}
                      onOpenChange={status => {
                        setEndYearOpen(status);
                      }}
                    />
                  ) : (
                    <MonthPicker
                      value={
                        mesFim && anoFim
                          ? normalizeDate(`${mesFim}/${anoFim}`)
                          : null
                      }
                      name="endDate"
                      id={`endDate`}
                      format="MM/YYYY"
                      locale={locale}
                      placeholder="Mês / Ano"
                      onChange={(value, dateString) => {
                        handleEndDate(dateString);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div style={{ paddingTop: 50 }}>
          <TitleSection>
            > Selecione a origem dos dados que você deseja fazer download:
          </TitleSection>

          <BoxRadios>
            {dataLcs.map(({ label, value }) => (
              <Radio
                key={value}
                onClick={() => setLc(value)}
                value={lc}
                checked={lc === value}
                disabled={
                  isProfile ||
                  (value !== 'indicadores_painel_geral' && downloadType === 'r')
                }
              >
                {label}
              </Radio>
            ))}
          </BoxRadios>
        </div>

        <div className="boxButtonSave">
          <ButtonBase onClick={getDownloadDados} disabled={loading}>
            {!loading ? 'Realizar download' : 'Realizando download...'}
          </ButtonBase>
        </div>
      </BoxContent>
    </div>
  );
};

export default Download;
